import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    paddingBottom: "10px",
  },
  title: {
    fontSize: "20px !important",
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: "14px !important",
    color: theme.palette.text.tertiary,
    marginTop: "4px !important",
  },
  sectionTitle: {
    fontSize: "16px !important",
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  sectionSubtitle: {
    fontSize: "12px !important",
    color: theme.palette.text.tertiary,
  },
  pageGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "8px",
  },
  pageCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "6px",
    padding: "8px 12px",
    borderRadius: "8px",
    backgroundColor: "#252A38",
    cursor: "pointer",
    minHeight: "37px",
    transition: "border-color 0.2s ease",
  },
  pageCardEnabled: {
    background: "#6C65D929 !important",
    border: "1px solid #6C65D97A !important",
  },
  pageCardDisabled: {
    border: "1px solid #606479",
  },
  pageCardContent: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flex: 1,
    minWidth: 0,
  },
  pageLabel: {
    fontSize: "13px !important",
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dashedButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px dashed #606479",
    backgroundColor: "transparent",
    color: theme.palette.text.tertiary,
    cursor: "pointer",
    fontSize: "12px",
    fontFamily: "inherit",
    transition: "border-color 0.2s ease, color 0.2s ease",
    "&:hover": {
      borderColor: "#6C65D9",
      color: theme.palette.text.primary,
    },
  },
  customPageChip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "8px",
    minWidth: "200px",
    fontSize: "12px !important",
    cursor: "pointer",
  },
  customPageChipEnabled: {
    background: "#6C65D929 !important",
    border: "1px solid #6C65D97A !important",
  },
  customPageChipDisabled: {
    border: "1px solid #606479",
  },
  customPagesRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    marginTop: "10px",
  },
  groupsRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "stretch",
    gap: "8px",
    marginTop: "10px",
  },
  newGroupCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    minWidth: "90px",
    minHeight: "100px",
    padding: "12px",
    borderRadius: "10px",
    border: "1px dashed #606479",
    backgroundColor: "transparent",
    color: theme.palette.text.tertiary,
    cursor: "pointer",
    fontSize: "13px",
    fontFamily: "inherit",
    transition: "border-color 0.2s ease, color 0.2s ease",
    "&:hover": {
      borderColor: "#6C65D9",
      color: theme.palette.text.primary,
    },
  },
  groupCard: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "12px",
    borderRadius: "10px",
    backgroundColor: "#252A38",
    minWidth: "280px",
    flex: 1,
    maxWidth: "420px",
  },
  groupCardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "10px",
  },
  groupCardTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  groupCardActions: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  groupPagesList: {
    fontSize: "13px !important",
    color: theme.palette.text.tertiary,
    lineHeight: 1.5,
  },
  toggleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px",
    borderRadius: "10px",
    border: "1px solid #3F404A !important",
    width: "500px !important",
  },
  reorderContainer: {
    overflowX: "auto",
    overflowY: "visible",
    marginTop: "10px",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#606479",
      borderRadius: "3px",
    },
  },
  reorderGroup: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    paddingLeft: 0,
    listStyle: "none",
    width: "max-content",
    minHeight: "48px",
    margin: 0,
  },
  reorderItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px",
    backgroundColor: "#252A38",
    cursor: "grab",
    flexShrink: 0,
    minWidth: "fit-content",
    userSelect: "none",
  },
  reorderItemLabel: {
    fontSize: "13px !important",
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
  },
  deleteButton: {
    color: "#E41F1F !important",
    padding: "4px !important",
  },
  editButton: {
    color: theme.palette.text.tertiary + " !important",
    padding: "4px !important",
  },
}));

export default useStyles;
